export const useIPFS = () => {
  const resolveLink = (url) => {
    if (!url || !url.includes("ipfs://")) return url;
    //this is slow since we migrate to pinata service
    return url.replace("ipfs://", "https://gateway.pinata.cloud/ipfs/");
  };

  return { resolveLink };
};
